


























































































import {Component, Vue} from 'vue-property-decorator';
import {HomeIcon} from '@/assets/inconfont/home';
import FooterComponent from '@/components/footer.vue';
import {FooterInfo} from '@/static/footer';
import {CourseCatalog} from '@/static/course';

// @ts-ignore
@Component({
  components: {
    FooterComponent,
    HomeIcon,
  }
})  export default class OfficialView extends Vue {
  private current = ['print'];
  private menuData = FooterInfo;

  /**返回顶部*/
  public onblockTop() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  /**课程菜单初始化*/
  get courseMenu() {
    let courseData: any = CourseCatalog;
    let ary: any = [];
    for (let course in courseData) {
      ary = ary.concat(
        {
          key: course,
          title: courseData[course].name,
          data: courseData[course].data,
        }
      );
    }
    return ary;
  }
}
